import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Header.css";
import Services from "./Service";

export default function   Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [showServices, setShowServices] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMobileMenuOpen(false);
    setShowServices(false);
  }, [location.pathname]);

  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [mobileMenuOpen]);

  const toggleMobileMenu = () => {
    setMobileMenuOpen((prev) => !prev);
    setShowServices(false);
  };

  const toggleServices = () => {
    setShowServices((prev) => !prev);
  };

  return (
    
    <header className="header" onMouseLeave={() => setShowServices(false)}>
      <div className="header-container">
        <div className="header-logo">
          <Link to="/">
            <img src="/Logo.svg" alt="Logo" />
          </Link>
        </div>

        <nav className="header-navlinks header-desktop">
          <div className="header-listing">
            <Link
              className="header-navitem"
              to="/ourwork"
              onClick={() => setShowServices(false)}
              onMouseEnter={() => setShowServices(false)}
            >
              Work
            </Link>
            <div
              role="button"
              tabIndex={0}
              className={`header-navitem ${showServices ? "active" : ""}`}
              onMouseEnter={() => {
                setShowServices(true);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") toggleServices();
              }}
              onClick={() => toggleServices()}
            >
              Services
              <img src="/ArrowDown.svg" alt="Dropdown" />
            </div>
            <Link
              className="header-navitem"
              to="/about"
              onClick={() => setShowServices(false)}
              onMouseEnter={() => setShowServices(false)}
            >
              About Us
            </Link>
            <Link
              className="header-navitem"
              to="/blog"
              onClick={() => setShowServices(false)}
              onMouseEnter={() => setShowServices(false)}
            >
              Blog
            </Link>
          </div>
        </nav>

        <Link
          to="/contact"
          className="header-cta header-email-cta header-desktop"
        >
          <img src="/Emailicon.svg" alt="Email" className="header-email-icon" />
          <span>Contact Us</span>
        </Link>

        <div className="header-right-icons">
          <Link
            to="/contact"
            className="header-cta header-email-cta header-mobile-icon"
          >
            <img
              src="/Emailicon.svg"
              alt="Email Icon"
              className="header-email-icon"
            />
          </Link>

          <div
            className={`header-hamburger ${mobileMenuOpen ? "open" : ""}`}
            onClick={toggleMobileMenu}
          >
            <div className="header-bar"></div>
            <div className="header-bar"></div>
            <div className="header-bar"></div>
          </div>
        </div>
      </div>

      {showServices && !mobileMenuOpen && (
        <div className="header-services-dropdown">
          <Services />
        </div>
      )}

      <div className={`header-mobile-menu ${mobileMenuOpen ? "open" : ""}`}>
        <Link className="header-navitem" to="/ourwork" onClick={toggleMobileMenu}>
          Work
        </Link>
        <div className="header-navitem" onClick={toggleServices}>
          Services
          <img src="/ArrowDown.svg" alt="Dropdown" />
        </div>
        {showServices && (
          <div className="header-services-dropdown">
            <Services />
          </div>
        )}
        <Link className="header-navitem" to="/about" onClick={toggleMobileMenu}>
          About Us
        </Link>
        <Link className="header-navitem" to="/blog" onClick={toggleMobileMenu}>
          Blog
        </Link>
      </div>

      {mobileMenuOpen && (
        <div className="header-backdrop" onClick={toggleMobileMenu}></div>
      )}
    </header>
  );
}
